/**
 * FUMÉ REWARDS — Main JS (v7 — máxima calidad de cámara)
 * Toda la lógica de puntos vive en la Edge Function `rewards`.
 * El navegador ya NO escribe a la base de datos ni conoce los códigos.
 * v5: sin entrada manual de códigos — los códigos de producto solo se aceptan escaneados.
 * v6: enfoque continuo, resolución alta, detector nativo, control de zoom.
 * v7: SIN zoom. Máxima resolución disponible + selección del lente trasero PRINCIPAL
 *     (el mismo que usa la app de cámara normal) + botón "cambiar cámara" si hay varios.
 * v8: TODOS los canjes piden datos (nombre, teléfono, dirección), también los digitales.
 *     El historial detecta recompensa física por reward_type (ya no por ship_address).
 */

const SUPABASE_URL = 'https://yynpokopatxqnifyxwqu.supabase.co';
// Clave pública (anon). Segura de exponer: con RLS cerrado no puede escribir nada;
// solo sirve para pasar el gateway. Toda escritura pasa por la Edge Function.
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl5bnBva29wYXR4cW5pZnl4d3F1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMzI5NzgsImV4cCI6MjA5NjYwODk3OH0.gCVdIs6GZMtragKF6JTy5y8IfzPYtjcQoZjOfeW9lyQ';
const FN_URL = SUPABASE_URL + '/functions/v1/rewards';

let SETTINGS = {
  colors:  { gold:'#C9A84C', bg:'#0a0a0a', bg2:'#111111' },
  tiers:   [{name:'BRONCE',min:0,mult:1},{name:'PLATA',min:500,mult:1.25},{name:'ORO',min:1000,mult:1.5},{name:'PLATINO',min:2500,mult:2}],
  points:  { recycle:20, buy:50, cooldownHours:24 },
  rewards: [],
};

function applyColors() {
  const c = SETTINGS.colors; if (!c) return;
  const r = document.documentElement.style;
  if (c.gold) r.setProperty('--fr-gold', c.gold);
  if (c.bg)   r.setProperty('--fr-bg',   c.bg);
  if (c.bg2)  r.setProperty('--fr-bg2',  c.bg2);
}

// ─── APP ───────────────────────────────────────────────────────────────────
const fumeRewards = (() => {
  const app = document.getElementById('fume-rewards-app');
  if (!app) return {};

  const shopifyId = app.dataset.customerId;
  const email     = app.dataset.customerEmail;
  const identifier = (email && email !== '' && email !== 'nil') ? email : shopifyId;
  const loggedIn   = identifier && identifier !== '' && identifier !== 'nil' && identifier !== 'null';
  if (!loggedIn) return {};

  let customer      = null;
  let qrScanner     = null;
  let activeFilter  = 'All';
  let pendingReward = null;
  let myRedemptions = [];
  let addrReward    = null;
  const TYPE_LABELS = { All:'TODOS', Merch:'MERCH', Discount:'DESCUENTOS', 'Gift Card':'TARJETAS DE REGALO', Product:'PRODUCTOS' };

  // ── API helper ──
  async function api(action, extra) {
    const res = await fetch(FN_URL, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'apikey': SUPABASE_ANON, 'Authorization': 'Bearer ' + SUPABASE_ANON },
      body: JSON.stringify(Object.assign({ action, customerId: shopifyId, email }, extra || {})),
    });
    let data = null;
    try { data = await res.json(); } catch(e) {}
    return data || { error: 'network' };
  }

  // ── INIT ──
  async function init() {
    setupTabs();
    showLoading(true);
    try {
      const setRes = await api('settings');
      if (setRes && setRes.settings) SETTINGS = Object.assign(SETTINGS, setRes.settings);
      applyColors();
      const meRes = await api('me');
      customer = (meRes && meRes.customer) ? meRes.customer : { pts:0, scans:0, redeemed:0, activity:[] };
      const hRes = await api('history');
      myRedemptions = (hRes && hRes.redemptions) ? hRes.redemptions : [];
    } catch(e) { console.error('Init error', e); }
    showLoading(false);
    refreshDash();
    updateNavPts();
  }

  function showLoading(on) {
    const el = document.getElementById('fr-loading');
    if (el) el.classList.toggle('hidden', !on);
  }

  // ── TABS ──
  function setupTabs() {
    document.querySelectorAll('.fr-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        document.querySelectorAll('.fr-tab').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.fr-page').forEach(p => p.classList.remove('active'));
        btn.classList.add('active');
        document.getElementById(`tab-${tab}`).classList.add('active');
        if (tab === 'scanner') initScanner(); else stopScanner();
        if (tab === 'store') renderStore();
        if (tab === 'dashboard') refreshDash();
        // Llevar la vista al inicio de la app para que el título de la sección
        // no quede escondido debajo de la barra de pestañas (sticky)
        const appEl = document.getElementById('fume-rewards-app');
        if (appEl) appEl.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    });
  }

  // ── DASHBOARD ──
  function getTier(pts) {
    const tiers = SETTINGS.tiers || [];
    for (let i = tiers.length - 1; i >= 0; i--) if (pts >= tiers[i].min) return tiers[i];
    return tiers[0] || { name:'BRONCE', min:0 };
  }

  function refreshDash() {
    if (!customer) return;
    const pts = customer.pts || 0;
    document.getElementById('fr-total-pts').textContent      = pts.toLocaleString();
    document.getElementById('fr-total-scans').textContent    = customer.scans || 0;
    document.getElementById('fr-total-redeemed').textContent = customer.redeemed || 0;

    const tier  = getTier(pts);
    const tiers = SETTINGS.tiers || [];
    document.getElementById('fr-tier').textContent      = tier.name;
    document.getElementById('fr-tier-name').textContent = tier.name;

    const nextTier = tiers.find(t => t.min > pts);
    let pct = 100, nextLabel = 'NIVEL MÁXIMO ALCANZADO';
    if (nextTier) {
      const range = nextTier.min - tier.min;
      const prog  = pts - tier.min;
      pct = Math.min(100, Math.round((prog / range) * 100));
      nextLabel = `${(nextTier.min - pts).toLocaleString()} pts para ${nextTier.name}`;
    }
    document.getElementById('fr-tier-fill').style.width = pct + '%';
    document.getElementById('fr-tier-next').textContent = nextLabel;

    const badgesEl = document.getElementById('fr-tier-badges');
    if (badgesEl) badgesEl.innerHTML = tiers.map(t => `<span class="fr-tb${t.name===tier.name?' fr-tb-active':''}">${esc(t.name)}</span>`).join('');

    const activity = customer.activity || [];
    const list = document.getElementById('fr-activity-list');
    if (!activity.length) { list.innerHTML = '<div class="fr-empty">Aún no hay actividad. ¡Escanea tu primer código!</div>'; return; }
    list.innerHTML = activity.slice().reverse().slice(0, 10).map(a => `
      <div class="fr-activity-item">
        <div>
          <div class="fr-activity-desc">${esc(a.desc)}</div>
          <div class="fr-activity-date">${new Date(a.date).toLocaleDateString()}</div>
        </div>
        <div class="fr-activity-pts">${a.pts > 0 ? '+' : ''}${a.pts} pts</div>
      </div>`).join('');
  }

  function updateNavPts() {
    if (!customer) return;
    const el = document.getElementById('fr-nav-pts');
    if (el) el.textContent = (customer.pts || 0).toLocaleString() + ' PTS';
  }

  // ── SCANNER ──
  let camList  = [];  // cámaras traseras disponibles, la principal primero
  let camIndex = 0;   // cámara activa

  function scannerConfig(deviceId) {
    // Máxima calidad: "ideal" nunca falla — el navegador entrega el modo más alto
    // que tenga la cámara elegida (4K si existe, si no lo máximo disponible).
    const vc = deviceId ? { deviceId: { exact: deviceId } } : { facingMode: 'environment' };
    vc.width  = { ideal: 3840 };
    vc.height = { ideal: 2160 };
    return {
      fps: 10,
      // Caja de escaneo responsiva: 70% del lado menor del visor
      qrbox: (vw, vh) => { const s = Math.floor(Math.min(vw, vh) * 0.7); return { width: s, height: s }; },
      // Detector nativo del navegador cuando existe: más rápido y tolera mejor el desenfoque
      experimentalFeatures: { useBarCodeDetectorIfSupported: true },
      videoConstraints: vc,
    };
  }

  // Lista las cámaras traseras y pone PRIMERO la principal (la que usa la app de
  // cámara normal): descarta por nombre los lentes secundarios (gran angular, macro,
  // telefoto, profundidad) y prefiere el índice más bajo del sistema.
  async function listBackCameras() {
    try {
      const cams = await Html5Qrcode.getCameras();
      if (!cams || !cams.length) return [];
      const back = cams.filter(c => /back|rear|tras|environment/i.test(c.label || ''));
      const pool = (back.length ? back : cams).slice();
      const score = c => {
        const l = (c.label || '').toLowerCase();
        let s = 0;
        if (/ultra|wide|angular|macro|tele|depth|profund/.test(l)) s += 10;
        const m = l.match(/\d+/);
        if (m) s += parseInt(m[0], 10) / 100;
        return s;
      };
      pool.sort((a, b) => score(a) - score(b));
      return pool;
    } catch(e) { return []; }
  }

  function initScanner() {
    if (qrScanner) return;
    qrScanner = new Html5Qrcode('fr-qr-reader');
    startCamera();
  }

  async function startCamera() {
    if (!qrScanner) return;
    if (!camList.length) { camList = await listBackCameras(); camIndex = 0; }
    const cam = camList[camIndex];
    const onCode = code => submitCode(code.trim());
    try {
      if (cam) await qrScanner.start({ deviceId: { exact: cam.id } }, scannerConfig(cam.id), onCode, () => {});
      else     await qrScanner.start({ facingMode:'environment' }, scannerConfig(null), onCode, () => {});
      tuneFocus();
      ensureCamUI();
    } catch(e) {
      // Si la cámara elegida falla, reintenta en modo genérico
      try {
        await qrScanner.start({ facingMode:'environment' }, scannerConfig(null), onCode, () => {});
        tuneFocus();
        ensureCamUI();
      } catch(e2) {
        const el = document.getElementById('fr-qr-reader');
        if (el) el.innerHTML =
          '<p class="fr-scanner-fallback">Cámara no disponible. Permite el acceso a la cámara en tu navegador e inténtalo de nuevo.</p>';
        qrScanner = null;
      }
    }
  }

  // Enfoque continuo si el celular lo soporta
  async function tuneFocus() {
    if (!qrScanner || typeof qrScanner.getRunningTrackCapabilities !== 'function') return;
    let caps = {};
    try { caps = qrScanner.getRunningTrackCapabilities() || {}; } catch(e) { return; }
    if (Array.isArray(caps.focusMode) && caps.focusMode.indexOf('continuous') !== -1) {
      try { await qrScanner.applyVideoConstraints({ advanced: [{ focusMode: 'continuous' }] }); } catch(e) {}
    }
  }

  // Si el navegador arrancó con un lente que no enfoca, el cliente puede pasar al siguiente
  async function switchCamera() {
    if (!qrScanner || camList.length < 2) return;
    camIndex = (camIndex + 1) % camList.length;
    try { await qrScanner.stop(); } catch(e) {}
    await startCamera();
  }

  function ensureCamUI() {
    const oldZoom = document.getElementById('fr-zoom-ctrl');
    if (oldZoom) oldZoom.remove(); // limpia la UI de zoom de v6 si quedara
    let btn = document.getElementById('fr-cam-switch');
    if (camList.length < 2) { if (btn) btn.style.display = 'none'; return; }
    if (btn) { btn.style.display = 'block'; return; }
    const reader = document.getElementById('fr-qr-reader');
    if (!reader || !reader.parentNode) return;
    const gold = (SETTINGS.colors && SETTINGS.colors.gold) || '#C9A84C';
    btn = document.createElement('button');
    btn.id = 'fr-cam-switch';
    btn.type = 'button';
    btn.textContent = '⟳ CAMBIAR CÁMARA';
    btn.style.cssText = 'display:block;margin:10px auto 0;background:none;border:1px solid ' + gold + ';color:' + gold + ';border-radius:10px;padding:10px 18px;font-weight:700;font-size:12px;letter-spacing:1px;cursor:pointer;font-family:inherit';
    btn.addEventListener('click', switchCamera);
    reader.parentNode.insertBefore(btn, reader.nextSibling);
  }

  function stopScanner() {
    if (qrScanner) { qrScanner.stop().catch(()=>{}); qrScanner = null; }
    const b = document.getElementById('fr-cam-switch');
    if (b) b.style.display = 'none';
  }

  async function submitCode(raw) {
    const code = (raw || '').toUpperCase().trim();
    hideErr('fr-scan-err'); hideScanSuccess();
    if (!code) return;
    let r;
    try { r = await api('scan', { code }); } catch(e) { r = { error:'network' }; }
    if (!r || r.error) { showErr('fr-scan-err', 'Error de conexión. Inténtalo de nuevo.'); return; }
    if (!r.ok) { showErr('fr-scan-err', r.message || 'No se pudo procesar el código.'); return; }
    if (r.customer) customer = r.customer;
    updateNavPts(); refreshDash();
    showScanSuccess({ name:r.product, type:r.type }, r.earned, r.mult || 1, { name:r.tier });
    if (qrScanner) { qrScanner.pause(true); setTimeout(() => { if (qrScanner) qrScanner.resume(); }, 8000); }
  }

  function showScanSuccess(product, earned, mult, tier) {
    ensureScanPopup();
    document.getElementById('fr-popup-pts').textContent     = '+' + earned;
    document.getElementById('fr-popup-label').textContent   = product.type === 'recycle' ? 'PUNTOS POR RECICLAJE' : 'PUNTOS POR COMPRA';
    document.getElementById('fr-popup-product').textContent = product.name || '';
    document.getElementById('fr-popup-total').textContent   = 'Total: ' + (customer.pts || 0).toLocaleString() + ' pts';
    const multEl = document.getElementById('fr-popup-mult');
    if (multEl) multEl.textContent = mult > 1 ? `×${mult} multiplicador ${tier.name}` : '';
    const overlay = document.getElementById('fr-popup-overlay');
    const bar = document.getElementById('fr-popup-bar-fill');
    overlay.classList.add('show');
    bar.style.transition = 'none'; bar.style.width = '0%';
    requestAnimationFrame(() => requestAnimationFrame(() => { bar.style.transition = 'width 10s linear'; bar.style.width = '100%'; }));
    if (window._popupTimer) clearTimeout(window._popupTimer);
    window._popupTimer = setTimeout(() => hideScanSuccess(), 10000);
  }
  function hideScanSuccess() { const o = document.getElementById('fr-popup-overlay'); if (o) o.classList.remove('show'); }

  function ensureScanPopup() {
    if (document.getElementById('fr-popup-overlay')) return;
    const gold = (SETTINGS.colors && SETTINGS.colors.gold) || '#C9A84C';
    const style = document.createElement('style');
    style.textContent = `
      #fr-popup-overlay{position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:99997;display:flex;align-items:flex-end;justify-content:center;opacity:0;pointer-events:none;transition:opacity .25s ease}
      #fr-popup-overlay.show{opacity:1;pointer-events:auto}
      #fr-popup-sheet{background:#111;border-radius:22px 22px 0 0;border-top:1px solid rgba(255,255,255,.08);width:100%;max-width:480px;padding:14px 20px 28px;text-align:center;transform:translateY(100%);transition:transform .35s cubic-bezier(.32,1.2,.5,1)}
      #fr-popup-overlay.show #fr-popup-sheet{transform:translateY(0)}
      #fr-popup-handle{width:36px;height:4px;background:#333;border-radius:2px;margin:0 auto 16px}
      #fr-popup-check{width:44px;height:44px;border-radius:50%;border:2px solid ${gold};display:flex;align-items:center;justify-content:center;margin:0 auto 10px;font-size:20px;color:${gold};font-weight:700}
      #fr-popup-pts{font-size:3rem;font-weight:800;color:${gold};letter-spacing:-1px;line-height:1}
      #fr-popup-label{font-size:.65rem;letter-spacing:3px;color:#888;margin-top:4px}
      #fr-popup-product{font-size:.9rem;color:#ddd;margin-top:8px;font-weight:600}
      #fr-popup-total{font-size:.75rem;color:#666;margin-top:4px}
      #fr-popup-bar-wrap{height:3px;background:#222;border-radius:2px;margin-top:18px;overflow:hidden}
      #fr-popup-bar-fill{height:100%;width:0%;background:${gold};border-radius:2px}
      #fr-popup-tap{font-size:.65rem;letter-spacing:1px;color:#555;margin-top:10px}`;
    document.head.appendChild(style);
    const overlay = document.createElement('div');
    overlay.id = 'fr-popup-overlay';
    overlay.innerHTML = `
      <div id="fr-popup-sheet">
        <div id="fr-popup-handle"></div>
        <div id="fr-popup-check">✓</div>
        <div id="fr-popup-pts">+50</div>
        <div id="fr-popup-label">PUNTOS</div>
        <div id="fr-popup-mult" style="font-size:.65rem;letter-spacing:2px;color:${gold};margin-top:4px;font-weight:700"></div>
        <div id="fr-popup-product"></div>
        <div id="fr-popup-total"></div>
        <div id="fr-popup-bar-wrap"><div id="fr-popup-bar-fill"></div></div>
        <div id="fr-popup-tap">Toca para cerrar</div>
      </div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener('click', () => { hideScanSuccess(); if (window._popupTimer) clearTimeout(window._popupTimer); });
  }

  // ── REWARDS STORE ──
  function renderStore() {
    const pts = customer?.pts || 0;
    const rewards = SETTINGS.rewards || [];
    document.getElementById('fr-store-pts').textContent = pts.toLocaleString() + ' PTS';
    const types = ['All', ...new Set(rewards.map(r => r.type))];
    document.getElementById('fr-filters').innerHTML = types.map(t =>
      `<button class="fr-filter${t===activeFilter?' active':''}" onclick="fumeRewards.filterBy('${t}')">${esc((TYPE_LABELS[t]||t).toUpperCase())}</button>`
    ).join('');

    let list = activeFilter === 'All' ? rewards.slice() : rewards.filter(r => r.type === activeFilter);
    list.sort((a,b) => a.pts - b.pts);
    document.getElementById('fr-rewards-grid').innerHTML = list.map(r => {
      const can = pts >= r.pts;
      const imgContent = r.image
        ? `<img src="${escAttr(r.image)}" alt="${escAttr(r.name)}" style="width:100%;height:100%;object-fit:cover;cursor:zoom-in" onclick="fumeRewards.zoomImage('${escAttr(r.id)}')"/><span class="fr-zoom-hint" onclick="fumeRewards.zoomImage('${escAttr(r.id)}')">⤢</span>`
        : esc(r.emoji || '🎁');
      return `<div class="fr-reward-card">
        <div class="fr-reward-img" style="${r.image?'padding:0;overflow:hidden;position:relative':''}">${imgContent}</div>
        <div class="fr-reward-body">
          <div class="fr-reward-tag">${esc(TYPE_LABELS[r.type]||r.type)}</div>
          <div class="fr-reward-name">${esc(r.name)}</div>
          <div class="fr-reward-desc">${esc(r.desc)}</div>
          <div class="fr-reward-footer">
            <div class="fr-reward-pts">${r.pts.toLocaleString()} <span>pts</span></div>
            <button class="fr-redeem-btn" ${can?'':'disabled'} onclick="fumeRewards.openModal('${escAttr(r.id)}')">${can?'CANJEAR':'TE FALTAN PUNTOS'}</button>
          </div>
        </div>
      </div>`;
    }).join('');

    const grid = document.getElementById('fr-rewards-grid');
    if (grid && !document.getElementById('fr-history-btn')) {
      ensureRedeemUI();
      const btn = document.createElement('button');
      btn.id = 'fr-history-btn'; btn.className = 'fr-history-btn'; btn.textContent = '📦 Mis Canjes';
      btn.addEventListener('click', openHistory);
      grid.parentNode.insertBefore(btn, grid);
    }
  }
  function filterBy(type) { activeFilter = type; renderStore(); }

  // ── IMAGE LIGHTBOX ──
  function ensureLightbox() {
    if (document.getElementById('fr-lightbox')) return;
    const style = document.createElement('style');
    style.textContent = `
      #fr-lightbox{position:fixed;inset:0;background:rgba(0,0,0,.92);display:flex;align-items:center;justify-content:center;z-index:99999;opacity:0;pointer-events:none;transition:opacity .2s ease;padding:24px}
      #fr-lightbox.show{opacity:1;pointer-events:auto}
      #fr-lightbox-img{max-width:100%;max-height:90vh;object-fit:contain;border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.6)}
      #fr-lightbox-close{position:absolute;top:18px;right:24px;font-size:40px;line-height:1;color:#fff;cursor:pointer;background:none;border:none}
      .fr-zoom-hint{position:absolute;bottom:8px;right:8px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;font-size:15px;cursor:zoom-in;pointer-events:auto}`;
    document.head.appendChild(style);
    const box = document.createElement('div');
    box.id = 'fr-lightbox';
    box.innerHTML = `<button id="fr-lightbox-close" aria-label="Cerrar">&times;</button><img id="fr-lightbox-img" alt=""/>`;
    box.addEventListener('click', e => { if (e.target.id !== 'fr-lightbox-img') closeImage(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeImage(); });
    document.body.appendChild(box);
  }
  function zoomImage(id) {
    const r = (SETTINGS.rewards || []).find(x => x.id === id);
    if (!r || !r.image) return;
    ensureLightbox();
    const box = document.getElementById('fr-lightbox');
    document.getElementById('fr-lightbox-img').src = r.image;
    document.getElementById('fr-lightbox-img').alt = r.name;
    box.classList.add('show');
  }
  function closeImage() { const b = document.getElementById('fr-lightbox'); if (b) b.classList.remove('show'); }

  // ── REDEEM / SHIPPING / HISTORY UI ──
  // v8: TODOS los canjes piden datos de contacto y envío (decisión del dueño 2026-08-17)
  function needsShipping(type) { return true; }
  function isPhysical(type) { return type === 'Merch' || type === 'Product'; }

  function ensureRedeemUI() {
    if (document.getElementById('fr-addr-overlay')) return;
    const gold = (SETTINGS.colors && SETTINGS.colors.gold) || '#C9A84C';
    const style = document.createElement('style');
    style.textContent = `
      .fr-ov{position:fixed;inset:0;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;z-index:99998;opacity:0;pointer-events:none;transition:opacity .2s;padding:18px}
      .fr-ov.show{opacity:1;pointer-events:auto}
      .fr-sheet{background:#111;border:1px solid rgba(255,255,255,.08);border-radius:16px;width:100%;max-width:440px;max-height:88vh;overflow:auto;padding:22px;color:#fff;box-shadow:0 24px 70px rgba(0,0,0,.6)}
      .fr-sheet h3{margin:0 0 4px;font-size:18px;letter-spacing:.5px}
      .fr-sheet .fr-sub{color:#999;font-size:13px;margin-bottom:16px}
      .fr-sheet .fr-sub.hidden{display:none}
      .fr-field{margin-bottom:12px}
      .fr-field label{display:block;font-size:12px;color:#bbb;margin-bottom:5px;text-transform:uppercase;letter-spacing:.5px}
      .fr-field input,.fr-field textarea{width:100%;box-sizing:border-box;background:#0a0a0a;border:1px solid rgba(255,255,255,.12);border-radius:9px;padding:11px 12px;color:#fff;font-size:14px}
      .fr-field textarea{resize:vertical;min-height:60px}
      .fr-sheet-actions{display:flex;gap:10px;margin-top:18px}
      .fr-btn-primary{flex:1;background:${gold};color:#000;border:none;border-radius:9px;padding:13px;font-weight:700;font-size:14px;cursor:pointer;letter-spacing:.5px}
      .fr-btn-ghost{flex:1;background:none;color:#bbb;border:1px solid rgba(255,255,255,.15);border-radius:9px;padding:13px;font-weight:600;font-size:14px;cursor:pointer}
      .fr-history-btn{display:block;width:100%;margin:0 0 16px;background:none;border:1px solid ${gold};color:${gold};border-radius:10px;padding:12px;font-weight:700;font-size:13px;letter-spacing:.5px;cursor:pointer}
      .fr-redo{border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:14px;margin-bottom:12px;background:#0d0d0d}
      .fr-redo-top{display:flex;justify-content:space-between;align-items:flex-start;gap:10px}
      .fr-redo-name{font-weight:700;font-size:15px}
      .fr-redo-meta{font-size:12px;color:#888;margin-top:2px}
      .fr-redo-pts{color:${gold};font-weight:700;font-size:13px;white-space:nowrap;margin-top:4px}
      .fr-badge{display:inline-block;font-size:11px;font-weight:700;padding:3px 9px;border-radius:20px;letter-spacing:.5px;text-transform:uppercase}
      .fr-step{display:flex;align-items:flex-start;margin-top:14px}
      .fr-step .s{flex:1;text-align:center;font-size:10px;color:#666;position:relative;text-transform:uppercase;letter-spacing:.3px}
      .fr-step .s .dot{width:12px;height:12px;border-radius:50%;background:#333;margin:0 auto 5px;border:2px solid #333;position:relative;z-index:1}
      .fr-step .s.done .dot{background:${gold};border-color:${gold}}
      .fr-step .s.done{color:#ddd}
      .fr-step .s::before{content:'';position:absolute;top:6px;left:-50%;width:100%;height:2px;background:#333;z-index:0}
      .fr-step .s:first-child::before{display:none}
      .fr-step .s.done::before{background:${gold}}
      .fr-track{font-size:12px;color:#aaa;margin-top:12px;word-break:break-all}
      .fr-redo-empty{color:#888;text-align:center;padding:30px 10px;font-size:14px}`;
    document.head.appendChild(style);

    const addr = document.createElement('div');
    addr.className = 'fr-ov'; addr.id = 'fr-addr-overlay';
    addr.innerHTML = `
      <div class="fr-sheet">
        <h3 id="fr-addr-title">DATOS DE ENVÍO</h3>
        <div class="fr-sub">Tus datos para contactarte y entregar tu recompensa.</div>
        <div class="fr-field"><label>Nombre completo</label><input id="fr-addr-name" type="text" autocomplete="name"/></div>
        <div class="fr-field"><label>Teléfono</label><input id="fr-addr-phone" type="tel" autocomplete="tel"/></div>
        <div class="fr-field"><label>Dirección</label><textarea id="fr-addr-address" autocomplete="street-address"></textarea></div>
        <div class="fr-field"><label>Ciudad</label><input id="fr-addr-city" type="text" autocomplete="address-level2"/></div>
        <div id="fr-addr-err" class="fr-sub hidden" style="color:#e66"></div>
        <div class="fr-sheet-actions">
          <button class="fr-btn-ghost" id="fr-addr-cancel">Cancelar</button>
          <button class="fr-btn-primary" id="fr-addr-submit">CONFIRMAR</button>
        </div>
      </div>`;
    document.body.appendChild(addr);
    addr.querySelector('#fr-addr-cancel').addEventListener('click', closeAddressForm);
    addr.querySelector('#fr-addr-submit').addEventListener('click', submitAddressForm);
    addr.addEventListener('click', e => { if (e.target === addr) closeAddressForm(); });

    const hist = document.createElement('div');
    hist.className = 'fr-ov'; hist.id = 'fr-hist-overlay';
    hist.innerHTML = `
      <div class="fr-sheet">
        <h3>MIS CANJES</h3>
        <div class="fr-sub">Tus recompensas canjeadas y el estado de envío.</div>
        <div id="fr-hist-list"></div>
        <div class="fr-sheet-actions"><button class="fr-btn-ghost" id="fr-hist-close">Cerrar</button></div>
      </div>`;
    document.body.appendChild(hist);
    hist.querySelector('#fr-hist-close').addEventListener('click', closeHistory);
    hist.addEventListener('click', e => { if (e.target === hist) closeHistory(); });
  }

  function openAddressForm(r) {
    ensureRedeemUI();
    addrReward = r;
    const prev = myRedemptions.find(x => x.ship_address);
    document.getElementById('fr-addr-name').value    = prev?.ship_name    || '';
    document.getElementById('fr-addr-phone').value   = prev?.ship_phone   || '';
    document.getElementById('fr-addr-address').value = prev?.ship_address || '';
    document.getElementById('fr-addr-city').value    = prev?.ship_city    || '';
    document.getElementById('fr-addr-title').textContent = 'ENVIAR: ' + (r.name || '').toUpperCase();
    document.getElementById('fr-addr-err').classList.add('hidden');
    document.getElementById('fr-addr-overlay').classList.add('show');
  }
  function closeAddressForm() { const el = document.getElementById('fr-addr-overlay'); if (el) el.classList.remove('show'); addrReward = null; }

  async function submitAddressForm() {
    if (!addrReward) return;
    const ship = {
      name:    document.getElementById('fr-addr-name').value.trim(),
      phone:   document.getElementById('fr-addr-phone').value.trim(),
      address: document.getElementById('fr-addr-address').value.trim(),
      city:    document.getElementById('fr-addr-city').value.trim(),
    };
    const err = document.getElementById('fr-addr-err');
    if (!ship.name || !ship.phone || !ship.address) { err.textContent = 'Por favor completa nombre, teléfono y dirección.'; err.classList.remove('hidden'); return; }
    const r = addrReward; closeAddressForm();
    await finalizeRedemption(r, ship);
  }

  // ── MODAL ──
  function openModal(id) {
    const r = (SETTINGS.rewards || []).find(x => x.id === id);
    if (!r) return;
    pendingReward = r;
    document.getElementById('fr-modal-emoji').textContent = r.emoji || '🎁';
    document.getElementById('fr-modal-title').textContent = 'CANJEAR: ' + (r.name || '').toUpperCase();
    const shipNote = ' A continuación ingresarás tus datos de contacto y envío.';
    document.getElementById('fr-modal-body').textContent =
      `Usa ${r.pts.toLocaleString()} puntos para: ${r.desc} Actualmente tienes ${(customer.pts||0).toLocaleString()} puntos.${shipNote}`;
    document.getElementById('fr-modal-confirm').onclick = confirmRedeem;
    document.getElementById('fr-modal').classList.remove('hidden');
  }
  function confirmRedeem() {
    if (!pendingReward) return;
    const r = pendingReward;
    if ((customer.pts||0) < r.pts) { showToast('¡No tienes suficientes puntos!'); closeModal(); return; }
    closeModal();
    if (needsShipping(r.type)) openAddressForm(r); else finalizeRedemption(r, null);
  }

  async function finalizeRedemption(r, ship) {
    if ((customer.pts||0) < r.pts) { showToast('¡No tienes suficientes puntos!'); return; }
    let res;
    try { res = await api('redeem', { rewardId: r.id, ship: ship || null }); } catch(e) { res = { error:'network' }; }
    if (!res || res.error) { showToast('El canje falló. Inténtalo de nuevo.'); return; }
    if (!res.ok) { showToast(res.message || 'No se pudo canjear.'); return; }
    if (res.customer) customer = res.customer;
    try { const h = await api('history'); myRedemptions = (h && h.redemptions) ? h.redemptions : myRedemptions; } catch(e) {}
    updateNavPts(); renderStore();
    showToast('¡Canjeado: ' + r.name + '!');
  }

  function closeModal() { document.getElementById('fr-modal').classList.add('hidden'); pendingReward = null; }

  // ── HISTORY ──
  async function openHistory() {
    ensureRedeemUI();
    document.getElementById('fr-hist-overlay').classList.add('show');
    const listEl = document.getElementById('fr-hist-list');
    listEl.innerHTML = '<div class="fr-redo-empty">Cargando…</div>';
    try { const h = await api('history'); myRedemptions = (h && h.redemptions) ? h.redemptions : []; } catch(e) {}
    renderHistory();
  }
  function closeHistory() { const el = document.getElementById('fr-hist-overlay'); if (el) el.classList.remove('show'); }

  function statusColor(s) { return { pending:'#C9A84C', processing:'#5b9bd5', shipped:'#5bd58a', delivered:'#3ec76f', cancelled:'#e06666' }[s] || '#888'; }

  function renderHistory() {
    const listEl = document.getElementById('fr-hist-list');
    if (!myRedemptions || !myRedemptions.length) { listEl.innerHTML = '<div class="fr-redo-empty">Aún no tienes canjes.</div>'; return; }
    const stages = ['pending','processing','shipped','delivered'];
    const stageLabels = { pending:'Pendiente', processing:'Procesando', shipped:'Enviado', delivered:'Entregado' };
    const statusLabels = { pending:'PENDIENTE', processing:'PROCESANDO', shipped:'ENVIADO', delivered:'ENTREGADO', cancelled:'CANCELADO' };
    listEl.innerHTML = myRedemptions.map(x => {
      const physical = isPhysical(x.reward_type);
      const st = (x.status || 'pending').toLowerCase();
      const col = statusColor(st);
      let progress = '';
      if (physical && st !== 'cancelled') {
        const idx = stages.indexOf(st);
        progress = `<div class="fr-step">${stages.map((s,i)=>`<div class="s${i<=idx?' done':''}"><div class="dot"></div>${stageLabels[s]}</div>`).join('')}</div>`;
      }
      const track = x.tracking ? `<div class="fr-track">Guía de rastreo: ${esc(x.tracking)}</div>` : '';
      const date  = x.created_at ? new Date(x.created_at).toLocaleDateString('es-HN') : '';
      return `<div class="fr-redo">
        <div class="fr-redo-top">
          <div>
            <div class="fr-redo-name">${esc(x.reward_name||'Recompensa')}</div>
            <div class="fr-redo-meta">${esc(TYPE_LABELS[x.reward_type]||x.reward_type||'')}${date?' • '+date:''}</div>
          </div>
          <div style="text-align:right">
            <span class="fr-badge" style="background:${col}22;color:${col}">${statusLabels[st]||st}</span>
            <div class="fr-redo-pts">−${(x.pts_spent||0).toLocaleString()} pts</div>
          </div>
        </div>
        ${progress}${track}
      </div>`;
    }).join('');
  }

  // ── HELPERS ──
  function esc(s) { return String(s==null?'':s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }
  function escAttr(s) { return esc(s).replace(/`/g,'&#96;'); }
  function showErr(id, msg) { const el = document.getElementById(id); el.textContent = msg; el.classList.remove('hidden'); }
  function hideErr(id) { const el = document.getElementById(id); if (el) el.classList.add('hidden'); }
  function showToast(msg) { const t = document.getElementById('fr-toast'); t.textContent = msg; t.classList.add('show'); setTimeout(() => t.classList.remove('show'), 3000); }

  init();
  return { submitCode, filterBy, openModal, closeModal, confirmRedeem, zoomImage, closeImage, openHistory };
})();
